import React, { FC, useContext } from 'react';
import find from 'lodash/find';

import campaignsResource from 'src/actions/campaigns/campaignsResource';
import { FormEditorProps } from 'src/presentation/components/forms/Form';
import { RecipientCollectionContext } from './RecipientCollections';
import RecipientCollectionDetails from 'src/presentation/components/pages/proactiveCommunications/components/shared/RecipientCollectionDetails';
import { useResourceValues } from 'src/presentation/hooks/useResource';
import useRouter from 'src/presentation/hooks/useRouter';

const dataAidPrefix = 'admin-recipient-collections-';

const RecipientCollectionsEditor: FC<FormEditorProps> = ({ item, context, root }) => {
  const { addRecipientFormComponent } = useContext(RecipientCollectionContext);

  const {
    match,
  }: {
    match: { url: string; params: { campaignId: string } };
  } = useRouter() as any;

  const { values: campaigns } = useResourceValues(campaignsResource);

  const campaign = find(campaigns, { id: match.params.campaignId });

  const AddRecipientsForm = addRecipientFormComponent;

  return item ? (
    <RecipientCollectionDetails data-aid={dataAidPrefix} item={item} />
  ) : (
    <AddRecipientsForm data-aid={dataAidPrefix} item={item} root={root} context={context} campaign={campaign} />
  );
};

export default RecipientCollectionsEditor;
